import enUS from './lang/en-US'
import zhCN from './lang/zh-CN'
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { getLang } from '@/utils'

Vue.use(VueI18n)

export default new VueI18n({
  locale: getLang() || 'zh-CN',
  fallbackLocale: 'zh-CN',
  silentTranslationWarn: true,
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS
  }
})
